import type { ImpactMotionRefs } from './useImpactMotion';

const IMPACT_GRAFISMO_SRC = '/img/grafismo-azul.png';
const LAYER_ORIGIN = 'absolute inset-0 origin-[-50px_50%] lg:origin-[-100px_50%]';

type GrafismoBackgroundProps = Pick<ImpactMotionRefs, 'parallaxRef' | 'warpRef'>;

function GrafismoBackground({ parallaxRef, warpRef }: GrafismoBackgroundProps) {
  return (
    <div className='pointer-events-none absolute inset-0 overflow-hidden'>
      <div ref={parallaxRef} className={LAYER_ORIGIN}>
        <div ref={warpRef} className={LAYER_ORIGIN}>
          <img
            alt=''
            aria-hidden='true'
            className='absolute top-1/2 -left-70.75 -mt-5.25 h-175 w-auto max-w-none -translate-y-1/2 -scale-x-100 lg:-left-168 lg:-mt-12.75 lg:h-429'
            src={IMPACT_GRAFISMO_SRC}
          />
        </div>
      </div>
    </div>
  );
}

export default GrafismoBackground;
